export const formatToDecimals = (n, m) => n.toFixed(m)

export const formatCurrencyValue = (value, maxDigits = 4) => {
  return value ? parseFloat(formatToDecimals(parseFloat(value), maxDigits)) : ''
}
